import React, { useState, useEffect } from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import axios from '../../constants/axios'
import NavBar from './NavBar'
export default function DenseTable() {
	const [data, setData] = useState([])

	useEffect(() => {
		axios
			.get('displayFeedback')
			.then(res => {
				// console.log(res.data.feedback)
				setData(res.data.feedback)
			})
			.catch(err => {
				// console.log(err.response)
			})
	}, [])
	return (
		<div>
			<NavBar />

			<div
				style={{
					marginTop: '20px',
					marginBottom: '10px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<div
					style={{
						// display: 'flex',
						// justifyContent: 'center',
						// alignItems: 'center',
						width: '80%',
						margin: 'auto',
					}}
				>
					<Paper>
						<TableContainer>
							<Table stickyHeader aria-label='sticky table'>
								<TableHead>
									<TableRow>
										<TableCell>Sr. No.</TableCell>
										<TableCell align='center'>Email Id</TableCell>
										<TableCell align='center'>Name</TableCell>
										<TableCell align='center'>Type</TableCell>
										<TableCell align='center'>Message</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{data.map((row, i) => (
										<TableRow key={i + 1}>
											<TableCell align='center'>{i + 1}</TableCell>
											<TableCell align='center'>{row.email}</TableCell>
											<TableCell align='center'>
												{row.fname + ' '}
												{row.lname}
											</TableCell>
											<TableCell align='center'>{row.type}</TableCell>
											<TableCell align='center'>{row.message}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</Paper>
				</div>
			</div>
		</div>
	)
}
